import types from "../types";

const initialState = [];

function cartReducer(state = initialState, { type, payload }) {
  switch (type) {
    case types.ADD_TO_CART:
      const product = state.find((item) => item.id === payload.product.id);
      if (product) {
        return state.map((item) => {
          if (item.id !== payload.product.id) return item;
          if (payload.addedFromProductPage)
            return { ...item, qty: Number(item.qty) + Number(payload.qty) };
          return { ...item, qty: Number(payload.qty) };
        });
      } else {
        return [...state, { ...payload.product, qty: Number(payload.qty) }];
      }

    case types.REMOVE_FROM_CART:
      return state.filter((product) => product.id !== payload.id);

    case types.RESET_CART:
      return initialState;

    default:
      return state;
  }
}

export default cartReducer;
